export function isValidDate(date: string) {
  const dateObj = new Date(date);
  return !isNaN(dateObj.getTime());
}
